<div class="row w-100 pt-3 text-center row-title">
    <div class="bold-text blue-color align-content-center w-100 pb-3 proc-title">Paiement non reçu
        par {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }}
    </div>
</div>

@for (payment of payments.data; track payment) {
    <table class="table table-striped border-top-0 payment-history">
        @if (payments) {
            <tr>
                <td class="force-width"><strong>Date :</strong> {{ payment.date }}</td>
                <td><strong>Montant :</strong> {{ decimalComma(payment.amount) }}€</td>
                <td align="right">
                    <strong>État :</strong>
                    <app-dot [payment]="payment" [className]="'payment_dot_status'"></app-dot>
                </td>
            </tr>
        }
        @if (!payment.file) {
            <tr>
                <td colspan="2"><strong>Type
                    :</strong> {{ payment.extra }} @if (payment.paymentId && payment.paymentId > 0) {
                    <span
                    >(Transaction N° {{ payment.paymentId }})</span>
                }
                </td>
            </tr>
        }
        @if (payment.file) {
            <tr>
                <td><strong>Type :</strong> {{ payment.extra }} @if (payment.paymentId && payment.paymentId > 0) {
                    <span>(Transaction N° {{ payment.paymentId }}
                        )</span>
                }</td>
                <td colspan="2"><span (click)="getCreditFile(payment)" class="credit-pdf">Télécharger votre avoir</span>
                </td>
            </tr>
        }
    </table>
}

@if (payments && payments?.totalItems > 5) {
    <div>
        <app-paginator></app-paginator>
    </div>
}

<div class="row w-100 text-left mt-2 pl-3">
    Si vous avez effectué un paiement qui n’apparaît pas dans la rubrique <a target="_blank" routerLink="/paiements">&nbsp;Paiements</a>,
    merci de compléter le formulaire ci-dessous.
</div>
<form [formGroup]="notConformFormGroup" (ngSubmit)="confirmation()">
    <div class="col-12 w-100">
        <div class="row w-100 mb-4 mt-4">
            <span class="bold-label-text" style="margin-top: 8px">Choisissez le type de paiement* :</span>
            <select name="type" formControlName="type" class="custom-select w-auto ml-2" (change)="setValidator()">
                <option value="">Sélectionnez un moyen de paiement :</option>
                <option value="card_or_account_debit">Prélèvement sur compte/carte bancaire</option>
                <option value="card_payment">Paiement par carte bancaire</option>
                <option value="check">Paiement par chèque</option>
                <option value="tip">Paiement par TIP</option>
            </select>
            @if (hasError('type')) {
                <div class="row w-100 ml-2 form-text error-message">
                    {{ getError('type') }}
                </div>
            }
        </div>

        @if (notConformFormGroup.controls.type.value === 'check') {
            <div class="row w-100 mb-4">
                <span class="bold-label-text">Numéro de chèque*</span>
                <input type="text" class="form-control" formControlName="checkNumber">
                @if (hasError('checkNumber')) {
                    <div class="row w-100 ml-2 form-text error-message">{{
                            getError('checkNumber')
                        }}
                    </div>
                }
            </div>
        }

        <div class="row w-100 mb-4">
            <span class="bold-label-text">Montant du paiement*</span>
            <input type="number" class="form-control" formControlName="amount">
            @if (hasError('amount')) {
                <div class="row w-100 ml-2 form-text error-message">{{ getError('amount') }}</div>
            }
        </div>

        <div class="row w-100 mb-4">
            <span class="bold-label-text">Date du paiement*</span>

            <mat-form-field>
                @if (notConformFormGroup.controls.date.value === '') {
                    <p class="datepicker-placeholder label">JJ/MM/AAAA</p>
                }
                <input matInput formControlName="date" [matDatepicker]="picker" [matDatepickerFilter]="dateRangeFilter">
                <mat-datepicker-toggle matSuffix [for]="picker">
                    <mat-icon id="calendar-icon" svgIcon="agenda" matDatepickerToggleIcon></mat-icon>
                </mat-datepicker-toggle>
                @if (hasError('date')) {
                    <div class="row w-100 ml-2 form-text error-message">{{ getError('date') }}</div>
                }
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="row form-group">
            <span class="bold-label-text float-left mt-2">Merci de joindre une copie de votre relevé bancaire montrant un débit de la part de {{ brand == 'lacarte' ? 'SFR Discover' : brand | titlecase }}
                sur votre compte pour la somme indiquée* :</span>
            <span class="btn btn-file ml-2 mt-2">Parcourir <input formControlName="file" type="file"
                                                                  accept="image/jpeg,image/jpg,image/png,application/pdf"
                                                                  (change)="getFile($event)"></span>
            @if (fileNameDisplay) {
                <span class="filename">{{ fileNameDisplay }}</span>
            }
            @if (hasError('file')) {
                <div class="row w-100 ml-2 form-text error-message">{{ getError('file') }}</div>
            }
        </div>
        <div class="row form-group w-100">
            <span class="text-left">Si besoin, vous pouvez nous apporter des précisions concernant ce paiement :</span>
            <textarea class="form-control mt-4" rows="20" formControlName="comment"></textarea>
        </div>
    </div>
    <div class="row w-100 pt-3 text-center">
        <div class="col-12 w-100 cta_container">
            <button type="button" class="cta_cancel column" (click)="cancel()">Annuler<span></span></button>
            <button type="submit" class="cta_btn level_2 column">Valider<span></span></button>
        </div>
    </div>
</form>
